// Selector de jornadas de un multievento: una fila de botones, uno por jornada
// (el patrón de la pestaña Material). El contenido de la pestaña cambia según
// la jornada elegida. Con `conTodas`, un primer botón "Todas" (jornadaId null).
//
// Props:
// - jornadas: lista de jornadas.
// - jornadaId: id de la jornada elegida (null = "Todas").
// - onChange(id | null).
// - etiqueta(j): contenido del botón (texto o nodos, p. ej. con un distintivo).
// - idDe(j): id de la jornada (por defecto j.id).
// - testid / prefijoTestid: data-testid del contenedor y de cada botón.
import React from 'react';

// En móvil (< 768 px) cada botón mide al menos 44 px de alto
const claseBoton = (activa) => `px-3 py-1.5 min-h-[44px] md:min-h-0 rounded-lg border text-sm font-semibold ${activa
  ? 'border-duetto-primary bg-[#E3F3EC] text-[#0F5E43]'
  : 'border-[#E1E6E3] bg-white text-[#16221D] hover:border-[#9FC7B6]'}`;

const SelectorJornadas = ({
  jornadas = [], jornadaId = null, onChange, etiqueta = null, idDe = null,
  conTodas = false, textoTodas = 'Todas', testid = 'selector-jornadas', prefijoTestid = 'selector-jornada',
}) => {
  const id = (j) => (idDe ? idDe(j) : j?.id);
  const texto = (j, i) => (etiqueta ? etiqueta(j, i) : (j?.etiqueta || `Jornada ${i + 1}`));
  if (!Array.isArray(jornadas) || jornadas.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-2" role="group" aria-label="Jornadas" data-testid={testid}>
      {conTodas && (
        <button
          type="button"
          onClick={() => onChange && onChange(null)}
          className={claseBoton(!jornadaId)}
          aria-pressed={!jornadaId}
          data-testid={`${prefijoTestid}-todas`}
        >
          {textoTodas}
        </button>
      )}
      {jornadas.map((j, i) => {
        const activa = id(j) === jornadaId;
        return (
          <button
            key={id(j)}
            type="button"
            onClick={() => onChange && onChange(id(j))}
            className={claseBoton(activa)}
            aria-pressed={activa}
            data-testid={`${prefijoTestid}-${id(j)}`}
          >
            {texto(j, i)}
          </button>
        );
      })}
    </div>
  );
};

export default SelectorJornadas;
